import { getOnlyNumber } from '~/core/utils/getOnlyNumber'

export const getFormattedPhone = (phone: string, {
  mask = '&## ###-##-##',
  phoneCode = '7',
} = {}) => {
  const maskLength = mask.replace(/[^&#]/g, '').length

  let digits = getOnlyNumber(phone)

  if (maskLength !== digits.length && digits.startsWith(phoneCode)) {
    digits = digits.slice(phoneCode.length)
  }

  if (maskLength !== digits.length) {
    return phone
  }

  let index = 0

  const filledMask = mask.split('').map(
    character => character === '#' || character === '&' ? digits[index++] : character,
  ).join('')

  return `+${phoneCode} ${filledMask}`
}
